module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ppp-differentpaths011htmlch03"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppdifferentpaths006#ppp-differentpaths006htmltoc"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The woman at the nurses’ station smiled. “May I help you?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Carla Beaumont fell asleep. Is that okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Sure. We’ll let her go for a little while before waking her up.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“All right. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I found the elevator at the end of the hall and pushed the down arrow. When the light went off and the doors opened, Carla’s new boyfriend stepped off. His eyes widened. “You left her alone?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Uh, yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He jerked a look down the hallway, like I’d deserted my friend while she gasped her last breaths.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“She’s fine,” I said. “The nurses are keeping an eye on her.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He fidgeted with the still tightly-rolled magazine. “Yeah. I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("A light caught on his belt buckle and I held up a hand to keep from getting blinded. “You met Carla dancing?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He nodded, a corner of his mouth tilting up. “Doing the "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("Boogie")]), _vm._v(". She was…it suited her.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I raised an eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“She’s been great,” Bryan continued. “With this whole car-jacking thing. Pretty brave. It hasn’t gotten her down at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yes.” I stared at the untamed adoration evident on his face. “She’s an amazing woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yeah. Yeah, I know.” He glanced down the hallway, toward the circle of rooms. “I guess I’ll get back to her, in case she needs me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“She’s asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Alarm lit his eyes. “Asleep?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“The nurses know.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Oh. Well, all right. But I still need to get back. Just in case.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("And he was gone, without a backward glance.")]), _vm._v(" "), _c('p', {
    staticClass: "sec"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("“So what, exactly, don’t you like about him?” Nick’s voice was clear, as if he were right in the room with me, rather than two hundred miles away.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I don’t know. He’s just…weird.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Weird. Sure. That explains it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Maybe it’s the cowboy thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What cowboy thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Pointy boots, hugeass belt buckle. I’m sure the five-gallon hat was in his car. Or hanging on some horse he tied to a post.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Nick laughed. “Well you know, you’ve got the "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("biker")]), _vm._v(" thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I leaned back on the kitchen chair and rested my head against the wall, looking at the clock. It was late, and I was tired. “I know, I know. Forgive me for being "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("mean")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Nah. I think you’re just ticked you didn’t know about him earlier.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("I considered it. “That could be. But it was like he was afraid of me when I walked into the room.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Like I said. Biker thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Whatever.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“So how’s Carla doing?” Something rustled on his end of the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“She seemed pretty upbeat, actually. Didn’t act like she’d just been mugged.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Something clanked, and I heard Nick breathing.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Although if you’d seen her face you’d think she’d been for a few too many rounds in the ring.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("A door slammed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Nick, what are you "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("doing")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“The dishes. If that’s okay with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Of course, you numbskull. But how come your sisters and mom aren’t there taking care of you?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He laughed again. “’Cause I didn’t tell them you went home. I want an evening—and a night’s sleep—without them hovering.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Don’t blame you.” I considered asking him how he was feeling, but decided against it. If there was something to tell, he’d tell it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Things went quiet on his end, like he’d stopped moving. “I have to say, though, that I wish you hadn’t had to leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Me, too, especially since Carla’s going to be fine.” I thought back to the moments before Lucy’s phone call that afternoon. “I at least wish Lucy could’ve waited a few more minutes to call.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Only a few more?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well,” I said, “in a few more minutes I don’t think you would’ve been answering the phone.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b98c178","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-differentpaths011.vue
// module id = 84
// module chunks = 0